import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as c } from "../../../../IconBase-CxZyIWw2.js";
const l = e((a, h) => /* @__PURE__ */ s.jsx(
  c,
  {
    ref: h,
    ...a,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 16,
        fill: "none",
        viewBox: "0 0 14 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsxs(
            "mask",
            {
              id: "mask0_2974_3410",
              width: 12,
              height: 16,
              x: 1,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M11.74 0H2.2C1.54 0 1 .54 1 1.2v13.6c0 .66.54 1.2 1.2 1.2h9.54c.66 0 1.2-.54 1.2-1.2V1.2c0-.66-.54-1.2-1.2-1.2m-.3 14.5H2.5v-13h8.94z"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M4.22 6.32h5.51c.41 0 .75-.34.75-.75s-.34-.75-.76-.75h-5.5a.749.749 0 1 0 0 1.5M7.22 3.91h2.5c.41 0 .75-.34.75-.75s-.33-.75-.74-.75h-2.5c-.41 0-.75.34-.75.75s.33.75.74.75M4.22 11.16h5.51c.41 0 .75-.34.75-.75s-.34-.75-.76-.75h-5.5a.749.749 0 1 0 0 1.5M4.22 8.75h5.51c.41 0 .75-.34.75-.75s-.34-.75-.76-.75h-5.5a.749.749 0 1 0 0 1.5M4.22 13.58h2.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.5a.749.749 0 1 0 0 1.5"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3410)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M-1 0h16v16H-1z" }) })
        ]
      }
    )
  }
));
l.displayName = "AgencyPlanIcon";
export {
  l as AgencyPlanIcon,
  l as default
};
//# sourceMappingURL=index.js.map
